import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';

import { ToasterService } from '../../../core/framework/toaster/toaster.service';
import { TokenGhub } from './token-ghub.model';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class AutenticacaoGhubService {

  constructor(private httpClient: HttpClient
              , private toasterService: ToasterService
              , private errorHandlerService: ErrorHandlerService) { }

  autenticarViaHealthlogApi() {
    return this.httpClient.get<TokenGhub>(`/api/gis/ghub/usuarioGis/v1/usuarioGis/autenticar`)
                .pipe(
                  map((response: TokenGhub) => {
                    this.salvarTokenDeAcesso(response.jwtToken);
                  })
                  , catchError( (err: any) => {
                    this.toasterService.error('Falha de autenticação para uso do mapa', err.message);
                    return empty();
                  })
                );
  }

  tokenDeAcessoEstaValido() {
    const token = localStorage.getItem('auth-token-ghub');
    if (token == null || token === 'undefined') {
      return false;
    }
    const jwtHelperService = new JwtHelperService();
    if (!jwtHelperService.isTokenExpired(token)) {
      return true;
    }
    else {
      return false;
    }
  }

  salvarTokenDeAcesso(token: string) {
    localStorage.setItem('auth-token-ghub', token);
  }

  getTokenDeAcessoValido() {
    if (this.tokenDeAcessoEstaValido()) {
        return localStorage.getItem('auth-token-ghub');
    }
    return null;
  }

  getTokenDeAcesso(): string {
    return localStorage.getItem('auth-token-ghub');
  }

  logout() {
    localStorage.removeItem('auth-token-ghub');
  }

}
